
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("bJLF2", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.72f84d79.js.map
